import { render, staticRenderFns } from "./YearlyEnergyProfile.vue?vue&type=template&id=2542c72f&scoped=true&"
import script from "./YearlyEnergyProfile.vue?vue&type=script&lang=js&"
export * from "./YearlyEnergyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542c72f",
  null
  
)

export default component.exports